import { h } from "preact";
import { VisualizerSectionCard, VisualizerProductCard, VisualizerArtCard, VisualizerSelectedArtCard } from './Cards';
import { Upload, Getty } from './Icons';



// Visualizer Panel Sections
export const VisualizerSections = (d) => {
  const sections = d['visualizer_sections'];
  const $this = d.$this;
  let imageSelected = d.$this.state.selectedItems && d.$this.state.selectedItems['artwork'],
  count = 1;
    
  return (  
    Object.keys(sections).map((section, index) => {
      let currentSection = sections[section],
      flow = $this.state.flow,
      supported = flow !== 'print' || section !== 'frame',

      // Matting - Business Requirements
      sMatting = $this.state.selectedItems && $this.state.selectedItems['matting'] && $this.state.selectedItems['matting'].type,
      mountExcluded;

      return supported ? (
        <div className="visualizer-selector-section">
          <div className="visualizer-selector-section-title">
            <h2>{ section === 'print' && flow === 'frame' ? 'Preview Image' : section }</h2>
            { section === 'print' && imageSelected && <a onClick={(e)=>{$this.setImage(false)}}>Change Artwork Type</a>}
          </div>
          <div className="visualizer-selector-section-items">
            { section === 'print' && $this.state.flow === 'frame' ? (
              <VisualizerSectionCard
                item={currentSection[0]}
                title={'PREVIEW IMAGE & DIMENSIONS'}
                section={currentSection[0].id}
                state={$this.state}
                togglePanel={$this.togglePanel}
                />
            ) : (
              Object.keys(currentSection).map((item, index) => (
                // Mounting - Business Requirements
                mountExcluded = (currentSection[item].id === 'mounting' ? (sMatting ? (sMatting.includes('FLOAT')) : false) : false),
                mountExcluded = (currentSection[item].id === 'mounting' && flow === 'frame') ? true : mountExcluded,
                !mountExcluded && <div className="visualizer-selector-section-item">
                  <VisualizerSectionCard
                    index={count++}
                    item={currentSection[item]}
                    section={currentSection[item].id}
                    state={$this.state}
                    togglePanel={$this.togglePanel}
                    />
                </div>
              ))
            )}
          </div>
        </div>
      ) : (
        <div className="visualizer-selector-section">
          <button className="btn button-secondary button--lg" onClick={(e)=> {$this.toggleState('flow', 'full')}}>Add A {section}</button>
        </div>
      )
    })
  )
}

// Visualizer Panels
export const VisualizerPrintPanels = (d) => {
  let $this = d.this,
  data = $this.state.data;

  return [
      <VisualizerArtPanel data={ true } name={'artwork'} $this={ $this } />,
      <VisualizerPrintPanel data={ data['printing'] } name={'printing'} $this={ $this } />,
      <VisualizerPanel data={ true } filter={'slider'} name={'print_border'} $this={ $this } />
    ];
}

export const VisualizerFramePanels = (d) => {
  let $this = d.this,
  frameSupported = $this.state.flow !== 'print',
  data = $this.state.data;
  if (!frameSupported) return;

  return [
      <VisualizerFramePanel data={ data['frame'] } name={'frame'} $this={ $this } />,
      <VisualizerPanel filter={'slider'} multiselect={true} data={ data['matting'] } name={'matting'} $this={ $this } />,
      <VisualizerPanel data={ data['mounting'] } name={'mounting'} $this={ $this } />,
      <VisualizerPanel data={ data['glazing'] } name={'glazing'} $this={ $this } />
    ];
}

// Visualizer Panel Wrapper
const VisualizerPanelSection = (d) => {
  let $this = d.$this,
  activePanel = $this.state.activePanel,
  type = d.type;
  return (
    <div className={`visualizer-selector-options ${activePanel === type ? ' open' : ''}`}
    data-panel={type}
    >
      <div 
        className="visualizer-selector-return"
        data-section={type}
        onClick={(e)=>{$this.togglePanel(e, true)}}
        >
        <span
          className="arrow-left"
        ></span>
      </div>
      <div 
        className="visualizer-selector-content">
        {d.children}
      </div>
    </div>
  )
}

// Visualizer Panel Content
const VisualizerPanel = (d) => {
  let $this = d.$this,
  data = d.data,
  type = d.name.toLowerCase(),

  // Matting - Business Requirements
  sMatting = $this.state.selectedItem && $this.state.selectedItem['matting'] && $this.state.selectedItem['matting'].type,
  matExcluded = (type === 'matting' ? (sMatting ? (sMatting.includes('NO MAT') || sMatting.includes('MOUNTED')) : false) : false);

  if(!data) return
  return (
    <VisualizerPanelSection type={type} $this={$this}>
      {data && Object.keys(data).map((item) =>
        <div className="visualizer-selector-section">
          {(!matExcluded || item === 'type') && <VisualizerPanelTitle title={`${item && item.replace("_", " ")}`} type={data[item].title} count={Object.keys(data[item].options).length} />}
          {(!matExcluded || item === 'type') && Object.keys(data[item].options).map((product) => (
            <VisualizerProductCard
              section={type}
              option={data[item].options[product]}
              type={item}
              pkey={product}
              multiselect={d.multiselect}
              thumbnail={data[item].options[product].image}
              image={data[item].options[product].visualizer_image}
              $this={$this}/>
          ))}
        </div>
      )}
      { !matExcluded && d.filter === 'slider' && <VisualizerSizeSlider type={type} $this={$this}/>}
    </VisualizerPanelSection>
  )
}

const VisualizerPrintPanel = (d) => {
  let $this = d.$this,
  data = d.data,
  type = d.name.toLowerCase();
  
  if(!data) return
  return (
    <VisualizerPanelSection type={type} $this={$this}>
      { data && Object.keys(data).map((item) =>
          Object.keys(data[item].options).map((section) => {
            let currentSection = data[item].options[section],
            sectionVisible = currentSection.visibility === 'full' || $this.state.flow === currentSection.visibility;
            return (sectionVisible) && [
              <div className="visualizer-selector-section">
                <VisualizerPanelTitle title={`${item && item.replace("_", " ")}`} type={currentSection.title} count={Object.keys(currentSection.options).length} />
                { Object.keys(currentSection.options).map((product) => {
                  let currentItem = currentSection.options[product],
                  itemVisible = currentItem.visibility === 'full' || $this.state.flow === currentItem.visibility;
                  return (itemVisible) && <VisualizerProductCard
                    section={type}
                    option={currentItem}
                    type={item}
                    pkey={section}
                    multiselect={d.multiselect}
                    thumbnail={currentItem.image}
                    image={currentItem.visualizer_image}
                    $this={$this}/>
                })}
              </div>
            ]
          })
      )}
    </VisualizerPanelSection>
  )
}

const VisualizerArtPanel = (d) => {
  let $this = d.$this,
  flow = $this.state.flow,
  uploaded = d.$this.state.selectedItems['artwork'] && d.$this.state.selectedItems['artwork'].type === 'upload',
  type = d.name.toLowerCase();

  return (
    <VisualizerPanelSection type={type} $this={$this}>
      <div className="visualizer-selector-section">
        <VisualizerPanelTitle title={type} type={type}/>
        {!$this.state.selectedItems[type] ? [
          <VisualizerArtCard
            title={'Upload an Image'}
            content={'Upload a photography or digital file to be printed.'}
            img={<Upload />}
            $this={$this}/>,

          $this.state.flow !== 'frame' && <VisualizerArtCard
            title={'Select from Getty Images'}
            content={'Select a image or artwork from our Gettyimages gallery.'}
            type={'getty'}
            img={<Getty />}
            $this={$this}/>
        ]: [
          <VisualizerSelectedArtCard
            type={type}
            $this={$this}/>
        ]}
      </div>
        
      { $this.state.selectedItems[type] && (
        <div className="visualizer-selector-section">
          <VisualizerPanelTitle title={'Dimensions'} type={'Dimensions'}/>
          <p className="visualizer-selector-section-description">Size shown reflects largest available print size. To resize your image, please edit the width and height below.</p>

          { !uploaded && (
            <div className="option-pricing">
              <div className="option-price">
                <p>Prints smaller than 16" x 16" </p>
                <p class="price">$35.00</p>
              </div>
              <div className="option-price">
                <p>Prints from 16" x 16" to 30" x 30"</p>
                <p class="price">$65.00</p>
              </div>
              <div className="option-price">
                <p>Prints larger than 30" x 30"</p>
                <p class="price">$95.00</p>
              </div>
            </div>
          )}
          <div className="option-sizing">
            <div className="option">
              <p>Width</p>
              <input type="number" onBlur={(e) => ($this.selectArtSize('width', e))} value={$this.state.selectedSizes.width}/>
            </div>
            <div className="option" >
              <p>Height</p>
              <input type="number" onBlur={(e) => ($this.selectArtSize('length', e))} value={$this.state.selectedSizes.length}/>
            </div>
          </div>
        </div>
      )}

      { $this.state.sizeError && <p className="error">Based on your image resolution, we do not recommend printing any larger than { Math.floor($this.state.sizeLimit)} inches wide.</p>}
      { $this.state.imageDimensions && (
        <div className="visualizer-dimensions-list">
          {$this.state.imageDimensions.map(dimension => (
            <div className="custom-input custom-input--product-size">
              <input type="radio" id={`dimension-${dimension.width}-${dimension.height}`}
                name="PreDefinedDimension" onChange={(e) => ($this.selectCustomArtSize(dimension))} />
              <label for={`dimension-${dimension.width}-${dimension.height}`}
                className="custom-label">{`${dimension.width}" x ${dimension.height}"`}</label>
            </div>
          ))}
        </div>
      )}
    </VisualizerPanelSection>
  )
}

const VisualizerFramePanel = (d) => {
  let $this = d.$this,
  data = d.data,
  type = d.name.toLowerCase(),
  imgBase = $this.state.imgBase,
  frames = []

  
  if(!data) return

  // Create Filter Subset
  data.map((item, i) => {
    let activeFilters = d.$this.state.activeFilters,
    filtered = true,
    sizeFiltered = true;

    activeFilters && Object.keys(activeFilters).map((filter, i) => {
      activeFilters[filter] && typeof activeFilters[filter][0] === 'object' ? activeFilters[filter].map((f, i) => {
        sizeFiltered = f.min <= parseInt(item[filter]) && (f.max ? f.max >= parseInt(item[filter]) : true)
      }) : 
        filtered = activeFilters[filter] ? activeFilters[filter].includes(item[filter]) : true;
      ;
    });
    filtered && sizeFiltered && frames.push(item);
  })

  return (
    <VisualizerPanelSection type={type} $this={$this}>
      <VisualizerPanelTitle type={type} count={frames.length} />
      <VisualizerFrameFilter $this={$this}/>
      { frames.map((item, i) => {
        return <VisualizerProductCard
          section={type}
          option={item}
          thumbnail={imgBase + item.visualizer_thumbnail}
          image={imgBase + item.visualizer_image}
          $this={$this}/>
      })}
    </VisualizerPanelSection>
  )
}

// Visualizer Panel Components
// Visualizer Panel Filters
const VisualizerSizeSlider = (d) => {
  let items = [],
  selectedSize = d.$this.state.selectedSizes ? d.$this.state.selectedSizes[d.type] : 0,
  preSelected = d.$this.state.selections && d.$this.state.selections[d.type],
  sizes = BORDERSIZES[d.type];
  selectedSize = d.$this.state.selectedSize ? d.$this.state.selectedSize[d.type] : selectedSize;

  items.push(<li onClick={(e)=> { d.$this.selectBorderSize(d.type, 0, e) }} className={selectedSize === 0 ? 'selected' : ''}><span>No {d.type.replace('print_', ' ')}</span></li>)
  for (let i = 0; i < sizes.length; i++) {
    items.push(<li onClick={(e)=> { d.$this.selectBorderSize(d.type, sizes[i], e) }} className={selectedSize === sizes[i] ? 'selected' : ''}><span>{ sizes[i] } Inches</span></li>)
  }
  return (
    <div className="visualizer-selector-section">
      <div className="visualizer-selector-title">
        <h4>Select { d.type.replace("_", " ") } Size</h4>
      </div>
      <div className="visualizer-selector-filter">
        <p>0 inches - { sizes[sizes.length - 1] } inches</p>

        { preSelected ? 
          <p className="description">We recommend a { selectedSize } inch matting size based on your selections.</p> :
          <p className="description">The most popular border size for 8" x 10" is 1 inch.</p>
        }
        <ul className="filter-slider">
          { items }
        </ul>
      </div>
    </div>
  )
}

const VisualizerFrameFilter = (d) => {

  let filters = d.$this.state.filters,
  activeFilters = d.$this.state.activeFilters;

  return <div className="visualizer-selector-filter">
    <span className="filter-toggle" onClick={(e)=>{e.target.classList.toggle('expanded');}}>Filter</span>
    <div className="filter-options">
      <div className="filter-options-container">
        { filters && Object.keys(filters).map((filter, index) => (
          <div className="filter-options-section">
            <div className="filter-options-section-title" onClick={(e)=>{e.target.classList.toggle('expanded');}}>
              {filter}
                { activeFilters[filter] && activeFilters[filter].length ? <div className="filter-options-selected">
                  { activeFilters[filter] && activeFilters[filter].length ? activeFilters[filter].map((item, i) => {
                      return `${i > 0 ? ', ': ''}${item.title ? item.title.toLowerCase() : item.toLowerCase()}`;
                    }) : ''}
                  </div> : ''
                }
            </div>
            <div className="filter-options-section-content">
              { FRAMEFILTERS[filter] ? FRAMEFILTERS[filter].map((item, i) => {
                let isSelected = false;
                if (activeFilters[filter] && activeFilters[filter].filter(e => e.min === item.min).length > 0) {
                   isSelected = true;
                }
                return item.title && <div className={`filter-option${isSelected ? ' selected' : ''}`} onClick={(e)=>{d.$this.filterFrames(item.title, filter, item);}}>{item.title.toLowerCase()}</div>
              }) : filters[filter].map((item, i) => {
                let isSelected = item && activeFilters[filter] && activeFilters[filter].includes(item);
                return item && <div className={`filter-option${isSelected ? ' selected' : ''}`} onClick={(e)=>{d.$this.filterFrames(item, filter);}}>{item.toLowerCase()}</div>
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
}

// Visualizer Panel Title
const VisualizerPanelTitle = (d) => (
  // console.log(d),
  <div className="visualizer-selector-title">
    <h4>{`Select ${d.type ? d.type : d.title}`}</h4>
    {d.count && (<span>{d.count} Option{d.count ? 's': ''}</span>)}
  </div>
)